<template>
  <v-card :style="backOpacity">
    <v-card-title v-if="type == 7">ラジオボタン CheckBoxForm.vue</v-card-title>
    <v-card-title v-if="type == 14"
      >チェックボックス CheckBoxForm.vue</v-card-title
    >
    <v-card-text>
      <v-container>
        <v-form ref="form">
          <v-row>
            rules:{{ rules }} rulesFlag:{{ rulesFlag }} length:{{
              rules.length
            }}
            <v-col cols="12">
              <v-text-field
                label="ラベル"
                v-model="returnData.label"
                required
                :hint="type == 7 ? '{{}}で囲うとhint表示' : ''"
                :persistent-hint="type == 7 ? true : false"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <set-Cols
                :value="String(returnData.cols)"
                v-on:set="$set(returnData, 'cols', $event)"
              ></set-Cols>
            </v-col>
          </v-row>
          <v-row>
            <p v-if="type == 14">初期値は"aa","bb" 区切り</p>
            <v-col cols="4">
              <v-text-field
                label="初期値"
                v-model="returnData.init"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-checkbox
                v-model="rules[2]"
                :label="rules[2] == 'other' ? '3段階選択(0,1,2)' : '非表示'"
                :value="
                  rules[2] == '' ? 'true' : rules[2] == 'true' ? 'other' : false
                "
                :on-icon="
                  rules[2] == 'true'
                    ? 'mdi-checkbox-marked'
                    : rules[2] == 'other'
                    ? 'mdi-close-box-outline'
                    : 'mdi-checkbox-blank-outline'
                "
                :off-icon="
                  rules[2] == 'true'
                    ? 'mdi-checkbox-marked'
                    : rules[2] == 'other'
                    ? 'mdi-close-box-outline'
                    : 'mdi-checkbox-blank-outline'
                "
                @change="rules[2] == 'other' ? (returnData.init = '0') : null"
              ></v-checkbox>
            </v-col>
            <v-col cols="2" v-if="rules[2] == false || rules[2] == 'other'">
              <v-checkbox
                v-model="rulesFlag[0]"
                label="入力不可"
                value="true"
              ></v-checkbox>
              0なら常に入力不可 (:)区切り 先頭に(&)で&&条件
            </v-col>
            <v-col cols="2">
              <v-checkbox
                v-model="rules[8]"
                label="必須"
                value="true"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2">
              <v-checkbox
                v-model="rules[5]"
                label="トグルセレクター"
                value="true"
              ></v-checkbox>
            </v-col>
            <v-col cols="3" v-if="rulesFlag[0]">
              <v-text-field
                v-model="rules[0]"
                :rules="[varidation.numANDNot]"
                label="リンクFromID"
                value="true"
              ></v-text-field>
              *0なら常に *先頭!で逆条件
            </v-col>
          </v-row>
          <v-row>
            <div v-for="(check, i) in checkbox" :key="i" class="mb-4">
              <v-col cols="12">
                <v-text-field
                  class="d-inline"
                  label="チェック項目"
                  v-model="returnData.checkbox[i]"
                  required
                ></v-text-field>
                <v-select
                  v-if="rules[5]"
                  :items="$store.state.colors"
                  :background-color="toggleColors[i]"
                  label="ボタンの色"
                  v-model="toggleColors[i]"
                ></v-select>
              </v-col>
            </div>
          </v-row>
          <v-row>
            <v-btn class="ma-1" color="red white--text" @click="del"
              >削除</v-btn
            >
            <v-btn class="ma-1" color="primary" @click="add">追加</v-btn></v-row
          >
          <v-row>
            <v-col cols="4">
              <v-checkbox
                v-model="rulesFlag[1]"
                label="切り替え時、特定フォームへ値代入"
                value="true"
              ></v-checkbox>
            </v-col>
            <v-col cols="10" v-if="rulesFlag[1]">
              <v-row v-for="(n, i) in assignCount" :key="i">
                <v-text-field
                  v-model="assignMyValue[i]"
                  :rules="[varidation.required]"
                  label="自身の値がxの時(xを指定)"
                ></v-text-field>
                <v-text-field
                  label="formID"
                  v-model="assignFormID[i]"
                  :rules="[varidation.required]"
                ></v-text-field>
                <v-text-field
                  label="サブページformID(同一ページなら0)"
                  value="0"
                  v-model="assignSubpageID[i]"
                  :rules="[varidation.required]"
                ></v-text-field>
                <v-text-field
                  label="代入する値"
                  v-model="assignValue[i]"
                  :rules="[]"
                  hint="空文字を代入する場合は空白でOK"
                ></v-text-field>
              </v-row>
              <v-btn v-if="rulesFlag[1]" color="success" @click="delAssign"
                >削除</v-btn
              >
              <v-btn v-if="rulesFlag[1]" color="success" @click="addAssign"
                >追加</v-btn
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <v-checkbox
                v-model="rulesFlag[3]"
                label="特定フォームに値を保存"
                value="true"
              ></v-checkbox>
            </v-col>
            <v-col cols="3" v-if="rulesFlag[3]">
              <v-text-field
                v-model="rules[3]"
                :rules="[varidation.numonly]"
                label="対象formID"
                hint="*値がchangeした場合のみ、発火するので初期値の設定が必要"
              ></v-text-field>
            </v-col>
            <v-col cols="3" v-if="rulesFlag[3]">
              <v-text-field
                v-model="rules[4]"
                :rules="[]"
                label="対象サブページのformID"
              ></v-text-field>
            </v-col>
            <v-col cols="3" v-if="rulesFlag[3]"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <v-checkbox
                v-model="rulesFlag[4]"
                label="追加ユーザフォームの特定の値で入力可不可切り替え"
                value="true"
              ></v-checkbox>
            </v-col>
            <v-col cols="2" v-if="rulesFlag[4]">
              <search-Page
                label="対象formID"
                v-model.number="rules4formID"
                required
              ></search-Page>
            </v-col>
            <v-col cols="2" v-if="rulesFlag[4]">
              <v-text-field
                v-model="rules4value"
                :rules="[]"
                label="指定の値"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" v-if="assignCount == 1">
              <v-checkbox
                v-model="rules[9]"
                label="1個前がプラスボタンでチェックを連動する"
                value="true"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        v-show="showButton"
        color="success"
        @click.once="submit"
        v-on:mouseover="backOpacity = 'opacity: 0.1'"
        v-on:mouseleave="backOpacity = 'opacity: 1'"
        fixed
        bottom
        right
        x-large
        class="mr-10 mb-8"
        >OK</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import setCols from "./common/setCols.vue";
import searchPage from "../ReportCreate/common/searchPage.vue";
export default {
  components: {
    setCols,
    searchPage,
  },
  props: {
    //共通値
    type: Number,
    position: Number,
    label: String,
    cols: String,
    //個別値
    init: String,
    checkbox: Array,
    rule: String,
  },
  data() {
    return {
      returnData: {
        //共通値
        type: this.type,
        position: this.position,
        label: this.label,
        cols: this.cols,
        //個別値
        init: this.init,
        checkbox: this.checkbox,
        value: this.value,
        rule: this.rule,
      },
      backOpacity: "opacity: 1",
      showButton: false,
      rulesFlag: [null, null, null],
      rules: [0, "", ""],
      assignCount: 1,
      assignMyValue: [],
      assignFormID: [],
      assignSubpageID: [],
      assignValue: [],
      rules4formID: "",
      rules4value: "",
      toggleColors: ["", "", ""],
      //
      varidation: {
        numonly: (value) => {
          return /^[0-9]*$/.test(value) || "数値のみ";
        },
        cols: (value) => {
          return /^([0-9]|1[0-2]|auto)$/.test(value) || "0~12,autoのみ";
        },
        numANDNot: (value) => {
          return /^[&!:0-9]*$/.test(value) || "数値か!のみ";
        },
        required: (value) => !!value || "必須項目です",
      },
    };
  },
  async mounted() {
    setTimeout(() => {
      this.showButton = true;
    }, 500);

    await this.getInit();
  },
  methods: {
    async getInit() {
      if (this.rule != "" && typeof this.rule != "undefined") {
        this.rules = this.rule.split(",");
      }
      for (let i = 0; i < this.rules.length; i++) {
        if (this.rules[i] != null && this.rules[i] != "") {
          this.$set(this.rulesFlag, i, "true");
        }
      }

      if (this.rules[7] != "" && typeof this.rules[7] != "undefined") {
        this.rulesFlag[4] = "true";
        [this.rules4formID, this.rules4value] = this.rules[7].split(".");
      }

      //「切り替え時、特定フォームへ値代入」分解処理
      if (this.rulesFlag[1]) {
        let assignArr = [];
        assignArr = this.rules[1].split(":");
        // assignArrの0番目は自身の値の条件が入るため1番目から代入先の条件が入っている
        this.rules[1] = assignArr[0];
        for (let i = 1; i < assignArr.length; i++) {
          const assignParam = assignArr[i].split(".");
          this.assignMyValue.push(assignParam[0]);
          this.assignFormID.push(assignParam[1]);
          this.assignSubpageID.push(assignParam[2]);
          this.assignValue.push(assignParam[3]);
        }
        this.assignCount = assignArr.length - 1;
      } else {
        //「切り替え時、特定フォームへ値代入」初期値設定
        this.assignSubpageID[0] = "0";
      }
      // トグルセレクターの色(rules[6])を配列に変換
      if (this.rules[5] && this.rules[6]) {
        this.toggleColors = this.rules[6].split(":");
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        for (let i = 0; i < this.rulesFlag.length; i++) {
          if (i != 2 && this.rulesFlag[i] == null) {
            this.rules[i] = "";
          }
        }

        //「切り替え時、特定フォームへ値代入」結合処理
        if (this.rulesFlag[1]) {
          for (let i = 0; i < this.assignMyValue.length; i++) {
            let assignStr = "";
            assignStr =
              this.assignMyValue[i] +
              "." +
              this.assignFormID[i] +
              "." +
              this.assignSubpageID[i] +
              "." +
              this.assignValue[i];
            this.rules[1] += ":" + assignStr;
          }
        }
        // トグルセレクターの色の配列を":"区切りの文字列に変換
        if (this.rules[5]) {
          this.rules[6] = this.toggleColors.join(":");
        } else {
          if (this.rules[6]) this.rules[6] = null;
        }
        if (this.rulesFlag[4]) {
          this.rules[7] = this.rules4formID + "." + this.rules4value;
        } else {
          this.rules[7] = "";
        }

        this.returnData.rule = this.rules.join(",");
        this.$emit("clickSubmit", this.returnData);
      }
    },
    add() {
      this.checkbox.push("value");
    },
    del() {
      if (this.checkbox.length > 1) {
        this.checkbox.splice(-1, 1);
      }
    },
    addAssign() {
      this.assignCount++;
      this.assignMyValue.push("");
      this.assignFormID.push("");
      this.assignSubpageID.push("0");
      this.assignValue.push("");
    },
    delAssign() {
      if (this.assignCount > 1) {
        this.assignCount--;
        this.assignMyValue.splice(-1, 1);
        this.assignFormID.splice(-1, 1);
        this.assignSubpageID.splice(-1, 1);
        this.assignValue.splice(-1, 1);
      }
    },
  },
};
</script>
